import { createTheme } from '@mui/material/styles'
import themeColors from 'assets/theme/colors'

// Custom theme for this app
const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: themeColors.gray.mid
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: themeColors.gray.mid,
          '&::placeholder': {
            color: themeColors.gray.mid,
            opacity: 1
          },
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px white inset',
            WebkitTextFillColor: themeColors.gray.mid
          }
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true
      },
      styleOverrides: {
        paper: {
          minWidth: '12rem',
          fontSize: '1rem',
          color: themeColors.gray[700],
          textAlign: 'left',
          listStyle: 'none',
          backgroundColor: '#fff',
          backgroundClip: 'padding-box',
          borderRadius: '.4375rem',
          padding: '.5rem 0'
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true
      },
      styleOverrides: {
        paper: {
          width: '100%'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          position: 'relative',
          padding: '1.5rem',
          flex: '1 1 auto'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          display: 'flex',
          padding: '1.25rem',
          borderBottomRightRadius: '.4375rem',
          borderBottomLeftRadius: '.4375rem',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      }
    }
  }
})

export default theme
